var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 490 490"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M245 456.701 490 33.299H0z"
})));
export { SvgTriangle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjEyIiB3aWR0aD0iMTIiIHZpZXdCb3g9IjAgMCA0OTAgNDkwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPHBvbHlnb24gcG9pbnRzPSIyNDUsNDU2LjcwMSA0OTAsMzMuMjk5IDAsMzMuMjk5ICIvPg0KPC9zdmc+";